
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[propertyId]",
      function () {
        return require("private-next-pages/properties/[propertyId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[propertyId]"])
      });
    }
  